import { PageContext } from 'context/PageContext';
import { useContext, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { loadCustomerProducts, setCustomerProducts } from 'store/slices/customerProductsSlice';
import { isAuthenticatedSession, loadCustomer, setCustomer } from 'store/slices/customerSlice';
import { getCustomerConceptDiscount } from '../services/CustomerConceptService';
import { mapCustomerData, setCustomerConcept } from '../services/CustomerService';
import { VERSION } from '../services/EnvironmentService';
import { useFormSubmit } from './useFormSubmit';

export const useFetchCustomer = () => {
	const dispatch = useAppDispatch();
	const customer = useAppSelector((state) => state.customer);
	const customerProducts = useAppSelector((state) => state.customerProducts);
	const pageContext = useContext(PageContext);
	const { onSubmit } = useFormSubmit();

	useEffect(() => {
		const call = async () => {
			if (!customer.isDataFetched && !customer.loading) {
				const auth = await dispatch(isAuthenticatedSession(pageContext.apiEndpoints));
				if (auth.meta.requestStatus === 'fulfilled') {
					const payload = {
						apiEndpoints: pageContext.apiEndpoints,
						auth: (auth.payload as { authenticated: boolean }).authenticated,
					};

					const customerDetails = await dispatch(loadCustomer(payload));
					if (customerDetails.meta.requestStatus === 'fulfilled') {
						dispatch(setCustomer(customerDetails.payload));
						await mapCustomerData(onSubmit);

						await getCustomerProducts(dispatch, pageContext, customerProducts);
					}
					onSubmit({ APP_VERSION: { id: 'APP_VERSION', value: VERSION, label: 'App. version' } });
				}
			}
		};
		call();
	}, [customer.isDataFetched]);

	useEffect(() => {
		const call = async () => {
			if (customerProducts.uniqueProducts) {
				const customerConceptDiscount = getCustomerConceptDiscount();
				await setCustomerConcept(customerConceptDiscount, onSubmit);
			}
		};
		call();
	}, [customerProducts.uniqueProducts]);
};

const getCustomerProducts = async (dispatch, pageContext, customerProducts) => {
	if (!customerProducts.isProductDataFetched && !customerProducts.loading) {
		const authResult = await dispatch(loadCustomerProducts(pageContext.apiEndpoints));
		if (authResult.meta.requestStatus === 'fulfilled') {
			dispatch(setCustomerProducts(authResult.payload));
		}
	}
};
